<header class="action-header">
  <div class="container">
    <div class="row">
      <div class="col-12"></div>
    </div>
  </div>
</header>

<ng-container *ngIf="!initialized">
  NOT INITIALIZED
</ng-container>

<!-- <ng-container *ngIf="!auctionLotService.auctionId && !auctionService.auction"> -->
<div *ngIf="!Auction" class="container page-auction-search">
  <div>
    <h1>Auction Search</h1>
  </div>
  <div class="alert alert-warning rounded-0 p-2">
    <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
    <span class="text-dark">There is no auction to display.</span>
  </div>

</div>

<div *ngIf="Auction" class="container page-auction-search">

  <div class="row position-xs-sticky">
    <div class="col-md-6 col-xs-12 d-flex justify-content-center justify-content-md-start">
      <div class="d-flex align-items-end justify-content-center flex-column flex-md-row">
        <h1 class="font-lg mb-0">Auction Search</h1>
        <div *ngIf="auctionLotService.auctionId && auctionService.initialized" class="ml-2">
          <!-- <label for="auction">Auction:</label> -->
          <select name="auction" class="bg-neutral-25 text-red font-sm outline-0 border-0" [(ngModel)]="auctionLotService.auctionId" (change)="OnAuctionChange(true)" style="max-width: 265px;">
            <option *ngFor="let auction of auctionService.auctions" [value]="auction.Id">{{auction.Title}} ({{auction.Id}})</option>
          </select>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-xs-12 d-flex align-items-center justify-content-center justify-content-md-end flex-wrap ">
      <div @fade class="d-flex justify-content-center flex-wrap bid-preview" *ngIf="myAuctionLotService.myAuctionLots$ | withLoading | async as myAuctionLots">
        <ng-template [ngIf]="myAuctionLots.value">
          <strong class="mr-1">Current:</strong>
          <div class="mr-1 right-outline">
            <span class="mr-1">Winning Bids</span> <span class="text-red mr-1">{{myAuctionLotService.currentWinningBids | inDollars}}</span>
          </div>
          <div class="mr-1 right-outline">
            <span class="mr-1">Maximum</span> <span class="text-red mr-1">{{myAuctionLotService.currentMaximum | inDollars}}</span>
          </div>
          <div class="mr-1">
            <span class="mr-1">BPA</span> <span class="text-red">{{myAuctionLotService.currentBpa | inDollars}}</span>
          </div>
        </ng-template>
        <ng-template [ngIf]="myAuctionLots.loading"><i @fade class="fa fa-spin fa-spinner"></i></ng-template>
      </div>

      <ng-template #loading><i @fade class="fa fa-spin fa-spinner"></i></ng-template>
    </div>

  </div>

  <div class="row auction-search-content mt-3">
    <auction-search-filter class="col-lg-3 col-xs-12 auction-search-filter" [filters]="auctionLotService.filters" (updated)="Updated()" (cleared)="Cleared()">
    </auction-search-filter>
    <div class="col-lg-9 col-xs-12">

      <div class="d-flex justify-content-lg-end justify-content-center" *ngIf="loggedIn">
        <label class="form-check">
          <input class="form-check-input" type="checkbox" (change)="changeVendorView()" [(ngModel)]="vendorView">
          <span class="">Show lots I am selling</span>
        </label>
      </div>


      <div class="auction-sort d-flex justify-content-lg-end justify-content-center mb-3 mt-3 mt-lg-0">
        <div class="text-center text-md-right pr-2 font-weight-bold" aria-hidden="true">Sort by: </div>
        <select class="form-select bg-neutral-25" aria-label="Sort by" [(ngModel)]="auctionLotService.sortBy" (change)="Updated()">
          <option *ngFor="let c of sortByOptions" [ngValue]="c.Id">{{c.Title}}</option>
        </select>
      </div>
      <div #pager></div>
      <div *ngIf="Auction && (!Auction.IsOpen || Auction.HasExpired)" class="alert alert-warning rounded-0 p-2">
        <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
        <span class="text-dark">The Auction is now Closed. Please refer to our Auction Calendar for details on upcoming auctions.</span>
      </div>
      <div #list class="auction-cards-container" *ngIf="initialized && auctionLotService.obs$ | withLoading | async as obs">
        <ng-template [ngIf]="obs.value">
          <div *ngIf="obs.value && obs.value.RowCount > 0" class="font-sm">{{obs.value.RowCount}} matching items</div>
          <div *ngIf="obs.value && obs.value.RowCount === 0" class="alert alert-warning rounded-0 p-2">
            <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
            <span class="text-opacity-7">No items were found. Try removing any recently-added filters.</span>
          </div>
          <!-- <auction-search-pagination [model]="obs.value" (setPage)="SetPage($event)" class="font-sm"></auction-search-pagination> -->
          <auction-search-card *ngFor="let lot of obs.value.Queryable" [lot]="lot"></auction-search-card>
          <auction-search-pagination [model]="obs.value" (setPage)="SetPage($event)"></auction-search-pagination>
        </ng-template>
        <ng-template [ngIf]="obs.loading"><i class="fa fa-spinner fa-spin"></i> Loading...</ng-template>
      </div>
      <ng-template #loading><i class="fa fa-spinner fa-spin"></i> Loading...</ng-template>
    </div>
  </div>
</div>
